"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import ErrorBoundary from "../../components/error_boundary";
import EmailForwarderWrapper from "../email_forwarder_wrapper";
import { ElementRoot } from "./element_root";
const FACTOR_INVOICE_ID_ATTR = "factor-invoice-id";
const EMAIL_ID_ATTR = "email-id";
const TAG = "ht-email-forwarder";
class EmailForwarderElement extends HTMLElement {
  constructor() {
    super(...arguments);
    __publicField(this, "root", new ElementRoot(this));
  }
  static get observedAttributes() {
    return [FACTOR_INVOICE_ID_ATTR, EMAIL_ID_ATTR];
  }
  connectedCallback() {
    this.renderFromAttributes();
  }
  attributeChangedCallback(name) {
    if (name === FACTOR_INVOICE_ID_ATTR || name === EMAIL_ID_ATTR) {
      this.renderFromAttributes();
    }
  }
  disconnectedCallback() {
    this.root.unmountSoon();
  }
  renderFromAttributes() {
    const factorInvoiceId = this.getAttribute(FACTOR_INVOICE_ID_ATTR);
    if (!factorInvoiceId) return;
    const emailId = this.getAttribute(EMAIL_ID_ATTR);
    this.root.render(
      React.createElement(
        ErrorBoundary,
        { name: "email-forwarder" },
        React.createElement(EmailForwarderWrapper, {
          factorInvoiceId: parseInt(factorInvoiceId, 10),
          emailId: emailId ? parseInt(emailId, 10) : void 0,
          onDone: (completed) => {
            this.dispatchEvent(
              new CustomEvent("forward-done", {
                bubbles: true,
                detail: completed
              })
            );
          },
          onCancel: () => {
            this.dispatchEvent(
              new CustomEvent("forward-cancelled", { bubbles: true })
            );
          }
        })
      )
    );
  }
}
if (!customElements.get(TAG)) {
  customElements.define(TAG, EmailForwarderElement);
}
